<script lang="ts" setup>
import { LoadingOutlined } from '@ant-design/icons-vue';
import { h } from 'vue';

interface Props {
  size?: string;
  ariaLabel?: string;
  ariaHidden?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  size: '2rem',
  ariaLabel: 'Loading',
  ariaHidden: true,
});

const indicator = h(LoadingOutlined, {
  style: {
    fontSize: props.size,
    color: 'var(--color-mid-green)',
  },
  spin: true,
});
</script>

<template>
  <div class="loading-spinner">
    <a-spin
      :indicator="indicator"
      :aria-label="ariaLabel"
      :aria-hidden="ariaHidden"
    />
  </div>
</template>

<style lang="less" scoped>
.loading-spinner {
  text-align: center;
}
</style>
